export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Smile"] = "Smile";
    FeedbackType["Frown"] = "Frown";
    FeedbackType["Idea"] = "Idea";
    FeedbackType["Unclassified"] = "Unclassified";
    FeedbackType["Survey"] = "Survey";
    FeedbackType["ThumbsUp"] = "ThumbsUp";
    FeedbackType["ThumbsDown"] = "ThumbsDown";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackAgeGroup;
(function (FeedbackAgeGroup) {
    FeedbackAgeGroup["Undefined"] = "Undefined";
    FeedbackAgeGroup["MinorWithoutParentalConsent"] = "MinorWithoutParentalConsent";
    FeedbackAgeGroup["MinorWithParentalConsent"] = "MinorWithParentalConsent";
    FeedbackAgeGroup["NotAdult"] = "NotAdult";
    FeedbackAgeGroup["Adult"] = "Adult";
    FeedbackAgeGroup["MinorNoParentalConsentRequired"] = "MinorNoParentalConsentRequired";
})(FeedbackAgeGroup || (FeedbackAgeGroup = {}));
export var FeedbackAuthenticationType;
(function (FeedbackAuthenticationType) {
    FeedbackAuthenticationType["MSA"] = "MSA";
    FeedbackAuthenticationType["AAD"] = "AAD";
    FeedbackAuthenticationType["Unauthenticated"] = "Unauthenticated";
})(FeedbackAuthenticationType || (FeedbackAuthenticationType = {}));
export var FeedbackPolicyValue;
(function (FeedbackPolicyValue) {
    FeedbackPolicyValue["Enabled"] = "Enabled";
    FeedbackPolicyValue["Disabled"] = "Disabled";
    FeedbackPolicyValue["NotConfigured"] = "Not Configured";
    /**
     * For feedback applications outside of M365, OCPS policies do not currently apply. This value
     * is an explicit indication of that condition. In other words, this value should not be used unless
     * the integrating partner is not part of M365 and knows that OCPS policies do not apply.
     */
    FeedbackPolicyValue["NotApplicable"] = "Not Applicable";
})(FeedbackPolicyValue || (FeedbackPolicyValue = {}));
export var FeedbackScreenshotInfoImageFormat;
(function (FeedbackScreenshotInfoImageFormat) {
    FeedbackScreenshotInfoImageFormat["JPEG"] = "jpeg";
    FeedbackScreenshotInfoImageFormat["PNG"] = "png";
})(FeedbackScreenshotInfoImageFormat || (FeedbackScreenshotInfoImageFormat = {}));
export var FeedbackScreenshotInfoImageOrientation;
(function (FeedbackScreenshotInfoImageOrientation) {
    FeedbackScreenshotInfoImageOrientation["Landscape"] = "Landscape";
    FeedbackScreenshotInfoImageOrientation["Potrait"] = "Potrait";
})(FeedbackScreenshotInfoImageOrientation || (FeedbackScreenshotInfoImageOrientation = {}));
/** All enums should be string */
export var FeedbackScreenshotSourceType;
(function (FeedbackScreenshotSourceType) {
    /** Default: used for normal web integration where the SDK is responsible for taking screenshot. */
    FeedbackScreenshotSourceType["AutoCapture"] = "AutoCapture";
    /** Used for web integration where the SDK is responsible for taking screenshot and displayMedia is not supported. */
    FeedbackScreenshotSourceType["AutoCaptureWithHtml2Canvas"] = "AutoCaptureWithHtml2Canvas";
    /** Used when hostapp provides the screenshot one time when it is initialized mainly used in mobile scenarios. */
    FeedbackScreenshotSourceType["ProvidedAtInitialization"] = "ProvidedAtInitialization";
    /** When screenshot is provided dynamically using callback, used in Win32, Mac, Android and iOS Scenarios. */
    FeedbackScreenshotSourceType["DynamicallyProvided"] = "DynamicallyProvided";
    /**
     * Where the host app wishes to dynamically provide the screenshot but cannot reliably deliver the render in less than the callback timeout. This should only apply where the host app is waiting on the user.
     */
    FeedbackScreenshotSourceType["DynamicallyProvidedWithNoTimeout"] = "DynamicallyProvidedWithNoTimeout";
})(FeedbackScreenshotSourceType || (FeedbackScreenshotSourceType = {}));
export var FeedbackUiType;
(function (FeedbackUiType) {
    /** Default: Used for side pane/detail view */
    FeedbackUiType["SidePane"] = "SidePane";
    /** Used for modal view */
    FeedbackUiType["Modal"] = "Modal";
    /** Used for in-screen pop up dialogue */
    FeedbackUiType["CallOut"] = "CallOut";
    /** Same as side pane but used inside an iframe */
    FeedbackUiType["IFrameWithinSidePane"] = "IFrameWithinSidePane";
    /** Same as modal but used inside an iframe */
    FeedbackUiType["IFrameWithinModal"] = "IFrameWithinModal";
    /** Same as callout but used inside an iframe */
    FeedbackUiType["IFrameWithinCallOut"] = "IFrameWithinCallOut";
    /** Used when the surface is provided by the host app */
    FeedbackUiType["NoSurface"] = "NoSurface";
    /** Used for in-screen pop up dialogue */
    FeedbackUiType["NoSurfaceWithoutTitle"] = "NoSurfaceWithoutTitle";
})(FeedbackUiType || (FeedbackUiType = {}));
export var FeedbackHostPlatformType;
(function (FeedbackHostPlatformType) {
    FeedbackHostPlatformType["Windows"] = "Windows";
    FeedbackHostPlatformType["IOS"] = "iOS";
    FeedbackHostPlatformType["Android"] = "Android";
    FeedbackHostPlatformType["WacTaskPane"] = "WacTaskPane";
    FeedbackHostPlatformType["MacOS"] = "MacOS";
    FeedbackHostPlatformType["Web"] = "Web";
    FeedbackHostPlatformType["IFrame"] = "IFrame";
})(FeedbackHostPlatformType || (FeedbackHostPlatformType = {}));
export var FeedbackHostEventName;
(function (FeedbackHostEventName) {
    FeedbackHostEventName["SubmitClicked"] = "InAppFeedback_HostEvent_SubmitClicked";
    FeedbackHostEventName["BackClicked"] = "InAppFeedback_HostEvent_BackClicked";
    FeedbackHostEventName["CancelClicked"] = "InAppFeedback_HostEvent_CancelClicked";
    FeedbackHostEventName["ReproductionModeStateUpdate"] = "InAppFeedback_HostEvent_ReproductionModeStateUpdate";
    FeedbackHostEventName["ScreenshotEditorAnnouncement"] = "InAppFeedback_HostEvent_ScreenshotEditorAnnouncement";
})(FeedbackHostEventName || (FeedbackHostEventName = {}));
export var InitializationStatus;
(function (InitializationStatus) {
    InitializationStatus["Success"] = "Success";
    InitializationStatus["Error"] = "Error";
    InitializationStatus["Warning"] = "Warning";
})(InitializationStatus || (InitializationStatus = {}));
export var InAppFeedbackQuestionUiType;
(function (InAppFeedbackQuestionUiType) {
    InAppFeedbackQuestionUiType["DropDown"] = "DropDown";
    InAppFeedbackQuestionUiType["MultiSelect"] = "MultiSelect";
    InAppFeedbackQuestionUiType["Rating"] = "Rating";
    InAppFeedbackQuestionUiType["SingleSelect"] = "SingleSelect";
    InAppFeedbackQuestionUiType["SingleSelectHorizontal"] = "SingleSelectHorizontal";
    InAppFeedbackQuestionUiType["Text"] = "Text";
    InAppFeedbackQuestionUiType["TextPills"] = "TextPills";
})(InAppFeedbackQuestionUiType || (InAppFeedbackQuestionUiType = {}));
export var InAppFeedbackScenarioType;
(function (InAppFeedbackScenarioType) {
    InAppFeedbackScenarioType["FeatureArea"] = "FeatureArea";
    InAppFeedbackScenarioType["ResponsibleAI"] = "ResponsibleAI";
    InAppFeedbackScenarioType["Experience"] = "Experience";
    InAppFeedbackScenarioType["ProductSatisfaction"] = "ProductSatisfaction";
    /** CrashImpact is of type Survey */
    InAppFeedbackScenarioType["CrashImpact"] = "CrashImpact";
    InAppFeedbackScenarioType["Custom"] = "Custom";
    InAppFeedbackScenarioType["AICustom"] = "AICustom";
    InAppFeedbackScenarioType["AIThumbsDown"] = "AIThumbsDown";
    InAppFeedbackScenarioType["AIThumbsUp"] = "AIThumbsUp";
    InAppFeedbackScenarioType["AIError"] = "AIError";
    InAppFeedbackScenarioType["AIGeneral"] = "AIGeneral";
    InAppFeedbackScenarioType["PromptSuggestion"] = "PromptSuggestion";
})(InAppFeedbackScenarioType || (InAppFeedbackScenarioType = {}));
export var InAppFeedbackQuestionUiBehaviour;
(function (InAppFeedbackQuestionUiBehaviour) {
    InAppFeedbackQuestionUiBehaviour["QuestionNotRequired"] = "QuestionNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentNotRequired"] = "CommentNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentRequiredWithLastOption"] = "CommentRequiredWithLastOption";
    InAppFeedbackQuestionUiBehaviour["TextPillsMultiSelect"] = "TextPillsMultiSelect";
})(InAppFeedbackQuestionUiBehaviour || (InAppFeedbackQuestionUiBehaviour = {}));
export var FeedbackAttachmentOrigin;
(function (FeedbackAttachmentOrigin) {
    FeedbackAttachmentOrigin["Application"] = "Application";
    FeedbackAttachmentOrigin["User"] = "User";
})(FeedbackAttachmentOrigin || (FeedbackAttachmentOrigin = {}));
export var FeedbackEntryPoint;
(function (FeedbackEntryPoint) {
    FeedbackEntryPoint["Header"] = "Header";
    FeedbackEntryPoint["Footer"] = "Footer";
    FeedbackEntryPoint["Backstage"] = "Backstage";
    FeedbackEntryPoint["HelpMenu"] = "Help Menu";
    FeedbackEntryPoint["Canvas"] = "Canvas";
    FeedbackEntryPoint["Chat"] = "Chat";
    FeedbackEntryPoint["VoiceChat"] = "VoiceChat";
    FeedbackEntryPoint["Pane"] = "Pane";
    FeedbackEntryPoint["BizChatLeftRail"] = "BizChatLeftRail";
    FeedbackEntryPoint["BizChatSidePane"] = "BizChatSidePane";
})(FeedbackEntryPoint || (FeedbackEntryPoint = {}));
export var FeedbackIntegrationSource;
(function (FeedbackIntegrationSource) {
    FeedbackIntegrationSource["MSO"] = "MSO";
    FeedbackIntegrationSource["SDX"] = "SDX";
    FeedbackIntegrationSource["VivaUX"] = "VivaUX";
    FeedbackIntegrationSource["OneShell"] = "OneShell";
    FeedbackIntegrationSource["Teams"] = "Teams";
    FeedbackIntegrationSource["Outlook"] = "Outlook";
})(FeedbackIntegrationSource || (FeedbackIntegrationSource = {}));
/**
 * The identity of the cloud the current tenant is hosted on.
 *
 * Certain clouds have specific restrictions around feedback collection. For example, `UsGovDod` tenants are not allowed
 * to provide feedback at all. In that specific case, we would expect the host app to disable the feedback button, but
 * we have a fallback check in the SDK as well.
 *
 * These values are from the M365 perspective. E.g. Azure would understand them slightly differently.
 *
 * See https://www.owiki.ms/wiki/ICE_Services/Config#Data_Boundary_Sovereignties for more information.
 */
export var TenantCloudType;
(function (TenantCloudType) {
    /**
     * The default cloud type that most tenants are hosted on. I.e. "Commercial" cloud
     */
    TenantCloudType["Worldwide"] = "Worldwide";
    TenantCloudType["China"] = "China";
    /**
     * European Union Data Boundary
     */
    TenantCloudType["EUDB"] = "EUDB";
    /**
     * Government Community Cloud (GCC)
     */
    TenantCloudType["GccMod"] = "GccMod";
    /**
     * Also known as GCC High
     *
     * Part of US Sovereign Cloud
     */
    TenantCloudType["UsGov"] = "UsGov";
    /**
     * US Government Department of Defense
     *
     * Part of US Sovereign Cloud
     */
    TenantCloudType["UsGovDod"] = "UsGovDod";
    /**
     * Treated the same as DoD by the Feedback SDK
     */
    TenantCloudType["UsNat"] = "UsNat";
    /**
     * Treated the same as DoD by the Feedback SDK
     */
    TenantCloudType["UsSec"] = "UsSec";
})(TenantCloudType || (TenantCloudType = {}));
/**
 * Determines what consent is required/allowed to contact the user via email for this feedback submission.
 */
export var EmailConsentType;
(function (EmailConsentType) {
    /**
     * Consent to contact the user via email was not requested. This generally means either policies prevent email contact,
     * or no email was supplied and the host application has not requested email collection.
     */
    EmailConsentType["NotRequested"] = "Not Requested";
    /**
     * The user did not provide explicit consent to contact them via email, but explicit consent was required.
     */
    EmailConsentType["None"] = "None";
    /**
     * The email (provided by the host application) was collected without an explicit checkbox presented to the user.
     * Microsoft will be restricted in how this email can be used for follow-up.
     *
     * This scenario happens under the following conditions:
     * - The explicit email collection control is not enabled
     * - An email is provided
     * - Email collection is not DISABLED by enterprise policy
     */
    EmailConsentType["Implicit"] = "Implicit";
    /**
     * An explicit checkbox was presented to the user requiring their consent to contact the user via email and they
     * provided their explicit consent to contact them via their email.
     */
    EmailConsentType["Explicit"] = "Explicit";
})(EmailConsentType || (EmailConsentType = {}));
/**
 * An internal type used to determine what sort of consent is being requested from the user for contacting them via
 * email. This is mostly used to determine how the UI should display the email collection controls.
 *
 * Once the user has submitted the feedback, it will be transformed into {@link EmailConsentType} when submitting to
 * Petrol.
 */
export var EmailConsentRequestType;
(function (EmailConsentRequestType) {
    /**
     * Consent to contact the user via email was not requested. This generally means either policies prevent email contact,
     * or no email was supplied and the host application has not requested email collection.
     */
    EmailConsentRequestType["NotRequested"] = "Not Requested";
    /**
     * The email (provided by the host application) will be collected without an explicit checkbox presented to the user.
     * Microsoft will be restricted in how this email can be used for follow-up.
     *
     * This scenario happens under the following conditions:
     * - The explicit email collection control is not enabled
     * - An email is provided
     * - Email collection is not DISABLED by enterprise policy
     */
    EmailConsentRequestType["Implicit"] = "Implicit";
    /**
     * An explicit checkbox will be presented to the user requiring their consent to contact the user via email. If the
     * email is not provided by the host application, the user may manually enter it.
     */
    EmailConsentRequestType["Explicit"] = "Explicit";
})(EmailConsentRequestType || (EmailConsentRequestType = {}));
export var UserAccessTokenAudience;
(function (UserAccessTokenAudience) {
    UserAccessTokenAudience["ODS"] = "ODS";
    UserAccessTokenAudience["TenantFeedback"] = "TenantFeedback";
})(UserAccessTokenAudience || (UserAccessTokenAudience = {}));
export var FeedbackScreenshotAutoCaptureConfigSetting;
(function (FeedbackScreenshotAutoCaptureConfigSetting) {
    FeedbackScreenshotAutoCaptureConfigSetting["Include"] = "include";
    FeedbackScreenshotAutoCaptureConfigSetting["Exclude"] = "exclude";
})(FeedbackScreenshotAutoCaptureConfigSetting || (FeedbackScreenshotAutoCaptureConfigSetting = {}));
export var ReproductionModeState;
(function (ReproductionModeState) {
    ReproductionModeState["Initial"] = "Initial";
    ReproductionModeState["UnknownError"] = "UnknownError";
    ReproductionModeState["StartInProgress"] = "StartInProgress";
    ReproductionModeState["StartSuccess"] = "StartSuccess";
    ReproductionModeState["StartError"] = "StartError";
    ReproductionModeState["StopInProgress"] = "StopInProgress";
    ReproductionModeState["StopSuccess"] = "StopSuccess";
    ReproductionModeState["StopError"] = "StopError";
    ReproductionModeState["CancelInProgress"] = "CancelInProgress";
    ReproductionModeState["CancelSuccess"] = "CancelSuccess";
    ReproductionModeState["CancelError"] = "CancelError";
    ReproductionModeState["RemoveInProgress"] = "RemoveInProgress";
    ReproductionModeState["RemoveSuccess"] = "RemoveSuccess";
    ReproductionModeState["RemoveError"] = "RemoveError";
})(ReproductionModeState || (ReproductionModeState = {}));
export var PrivacyConsentBlockKey;
(function (PrivacyConsentBlockKey) {
    PrivacyConsentBlockKey["CAI"] = "CAI";
    PrivacyConsentBlockKey["M365"] = "M365";
    PrivacyConsentBlockKey["WINDOWSSYS"] = "WINDOWSSYS";
    PrivacyConsentBlockKey["WINDOWSNONSYS"] = "WINDOWSNONSYS";
})(PrivacyConsentBlockKey || (PrivacyConsentBlockKey = {}));
/**
 * Represents the organization context.
 * This enum is intended to provide a broader naming convention compared to `PrivacyConsentBlockKey`.
 *
 * Usage:
 * - Use this enum to specify the organization context in configurations.
 */
export var OrganizationKey;
(function (OrganizationKey) {
    OrganizationKey["CAI"] = "CAI";
    OrganizationKey["M365"] = "M365";
    /**
     * For system components and non-uninstallable Windows apps
     */
    OrganizationKey["WINDOWSSYS"] = "WINDOWSSYS";
    /**
     * For uninstallable Windows apps
     */
    OrganizationKey["WINDOWSNONSYS"] = "WINDOWSNONSYS";
    OrganizationKey["XBOX"] = "XBOX";
})(OrganizationKey || (OrganizationKey = {}));
export var TenantFeedbackScenarioType;
(function (TenantFeedbackScenarioType) {
    /**
     * Feedback for conversation-based Copilot, for example BizChat or CWC
     */
    TenantFeedbackScenarioType["CopilotChatFeedback"] = "CopilotChatFeedback";
    /**
     * General feedback without any specified Copilot output
     */
    TenantFeedbackScenarioType["CopilotGlobalFeedback"] = "CopilotGlobalFeedback";
    /**
     * General feedback for catch-up/feeding content
     */
    TenantFeedbackScenarioType["CopilotCatchUpFeedback"] = "CopilotCatchUpFeedback";
    /**
     * Feedback for assistant (non-conversational) features, such as email summary, meeting recap, doc rewrite, etc
     */
    TenantFeedbackScenarioType["CopilotAssistantFeedback"] = "CopilotAssistantFeedback";
})(TenantFeedbackScenarioType || (TenantFeedbackScenarioType = {}));
// This list comes from `GetCountryCodeToRegionNameMap()` in
// https://dev.azure.com/office/CLE/_git/OfficeCustomerVoice?path=/Library/Common/Globalization/Regions.cs
export var AllowedClientCountryCodes = [
    'AA',
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AN',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'XE',
    'XJ',
    'XK',
    'XS',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
    'ZZ',
];
export var ComplianceMapping = {
    connectedExperiences: {
        settingId: 'office16;L_ConnectedOfficeExperiences',
        enabledValue: '1',
        disabledValue: '2',
    },
    policyAllowFeedback: {
        settingId: 'office16;L_SendFeedback',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowLimitedFeedback: {
        settingId: 'office16;L_LimitedFeedback',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowCopilotFeedback: {
        settingId: 'office16;L_SendCopilotFeedback',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowSurvey: {
        settingId: 'office16;L_SendSurvey',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowScreenshot: {
        settingId: 'office16;L_Screenshot',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowContact: {
        settingId: 'office16;L_EmailCollection',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyAllowContent: {
        settingId: 'office16;L_LogCollection',
        enabledValue: '1',
        disabledValue: '0',
    },
    policySendPublicFeedback: {
        settingId: 'feedback;L_SendPublicFeedback',
        enabledValue: '1',
        disabledValue: '0',
    },
    optionalConnectedExperiences: {
        settingId: 'office16;L_OptionalConnectedExperiences',
        enabledValue: '1',
        disabledValue: '2',
    },
    policyEmailCollectionDefault: {
        settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsEmail',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyScreenshotDefault: {
        settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsScreenshot',
        enabledValue: '1',
        disabledValue: '0',
    },
    policyContentSamplesDefault: {
        settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsContentSamples',
        enabledValue: '1',
        disabledValue: '0',
    },
};
